module.exports = __webpack_public_path__ + "static/media/CD__0001_0001.e15358ae.png";